export default {
  methods: {
    ellipse(item = '') {
      const intViewportWidth = window.innerWidth
      let numChars
      if (intViewportWidth > 893) {
        numChars = 30
      } else if (intViewportWidth > 767) {
        numChars = 20
      } else {
        numChars = 50
      }
      if (item.length > numChars) {
        return item.substring(0, numChars - 1) + '...'
      } else {
        return item
      }
    }
  }
}
